import { Button } from '@mui/material'
import { forwardRef } from 'react'
import { appButtonStyles } from './style'

const AppButton = forwardRef((props, ref) => {
  const classes = appButtonStyles()

  let {
    text,
    fill,
    disabled
  } = props

  return <>
    <Button
      {...props}
      ref={ref}
      disableRipple
      disableFocusRipple
      className={classes.ButtonBox + (fill ? '' : (' ' + classes.PlainButtonBox)) + (` ${props.className}` || '') + (disabled ? ` ${classes.disable}` : '')}
    >
      {text}
    </Button>
  </>
})

AppButton.defaultProps = {
  text: "",
  fill: true
}

export default AppButton